import { UseFormReturn } from 'react-hook-form';
import { countDirtyFields } from '../../count-dirty-fields';
import { EventPanelMetadataStore } from '../../event-state/event-panel-metadata-store';
import { EventPanelFormType } from '@mark43/cad-api';

export const getEventButtonGuardBooleans = (
    eventMetadataStore: EventPanelMetadataStore,
    eventForm: UseFormReturn<EventPanelFormType>
) => {
    const { eventId } = eventMetadataStore?.state.metadata || {};
    const eventExists = !!eventId;
    const isScheduledEvent = eventExists && eventMetadataStore.state.metadata?.isScheduledEvent;
    const isClearedEvent =
        eventExists && !eventMetadataStore.state.metadata?.isActive && !isScheduledEvent;
    const isExternalAgencyEvent =
        eventExists && eventMetadataStore.state.metadata?.isAgencyExternal;
    const isActiveAgencyEvent =
        eventExists && !isScheduledEvent && !isExternalAgencyEvent && !isClearedEvent;
    const hasDirtyFields = countDirtyFields(eventForm.formState.dirtyFields) > 0;
    const showGenerateRenPrimaryAgencyButton =
        eventMetadataStore.state.metadata?.showGenerateRenPrimaryAgencyButton;

    return {
        eventExists,
        isActiveAgencyEvent,
        isClearedEvent,
        hasDirtyFields,
        showGenerateRenPrimaryAgencyButton,
    };
};
